import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import DevicesOutlinedIcon from "@mui/icons-material/DevicesOutlined";

export const COUPON_FORM_STEP_ICONS = {
  1: ArticleOutlinedIcon,
  2: DateRangeOutlinedIcon,
  3: LocalOfferOutlinedIcon,
  4: BarChartOutlinedIcon,
  5: FilterListOutlinedIcon,
  6: Inventory2OutlinedIcon,
  7: DevicesOutlinedIcon,
};
